import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useSelector } from "react-redux";
import AddEditAnexo from "../partes/AddEditAnexo";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "auto",
  height: "auto",
  borderRadius: 5,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  flexDirection: "column",
  display: "flex",
};

export default function BasicModal(props) {
  const { btnLabel, datos } = props;
  const [open, setOpen] = React.useState(false);
  const { openRedux } = useSelector((state) => state.userState);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  React.useEffect(() => {
    setOpen(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openRedux]);


  const changeProps = () => {
    
  let infoContainer = null;
    switch (btnLabel) {
      case "Agregar anexos":
        return (infoContainer = {
          titulo: "Agregar anexo",
          backgroundColor: "#f4796d85",
        });
      
      case "Editar anexos":
        return (infoContainer = {
          titulo: "Editar anexo",
          backgroundColor: "#f4796d85",
        });

        case "Eliminar anexos":
          return (infoContainer = {
            titulo: "Eliminar anexo",
            backgroundColor: "red",
          });
      default:
        // eslint-disable-next-line no-unused-vars
        return (infoContainer = {
          titulo: "default",
          backgroundColor: "#f4796d85",
        });
    }
  };
  const styleClose = {
    width: "auto",
    height: 30,
    backgroundColor: "red",
    alignSelf: "flex-end",
    paddingLeft: 20,
    paddingRight: 20,
    marginTop: -80,
    position: "absolute",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    color: "#FFF",
    cursor: "pointer",
  };
  
  return (
    <div style={{display: 'inline-block'}}>
      <Button
        style={{
          width: "auto",
          height: "auto",
          backgroundColor: changeProps().backgroundColor,
          marginLeft: 20,
          marginRight: 20,
          marginBottom: 20,
        }}
        onClick={handleOpen}
        variant="contained"
      >
        <p style={{ fontSize: 10 }}>{btnLabel}</p>
      </Button>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
        <div style={styleClose} onClick={handleClose}>
            cerrar
          </div>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {changeProps().titulo}
          </Typography>
          {(btnLabel === "Editar anexos" || btnLabel === "Crear anexo" || btnLabel === "Eliminar anexo") ? (
            <AddEditAnexo datos={datos} />
          ) : null}
        </Box>
      </Modal>
    </div>
  );
}
